(function($){
	$(document).ready(function() {
	
		// console.log('cur-product-accessories-hero.js loaded!');

		window.addEventListener('pplrAppInitiated', function() {
			renderPplrUpcharges();
			renderTotal();
		});

		function renderPplrUpcharges() {
			$('.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer .pplr-swatch-element').each(function() {
				var price = parseFloat($(this).data('pplr_price'));
				if (price > 0) {
					var displayPrice = '+<sup>$</sup>' + price.toLocaleString();
					// $(this).find('.swtooltip span').append('<span class="pplr-ttupchg">(' + displayPrice + ')</span>');
					if ($(this).find('.pplr-upcharge').length === 0) {
						$(this).append('<span class="pplr-upcharge">' + displayPrice + '</span>');
					}
				}
			});
		}

		var $hero   = $('.cur-section.cur-product-accessories-hero');
		var $images = $hero.find('.gallery .product-images-container');
		var $thumbs = $hero.find('.gallery .product-thumbs-container');

		var pplrSel = '.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer';
		function getPplr() {
			return $(pplrSel);
		}

		$images.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			fade: true,
			swipe: false,
    		accessibility: true,
			asNavFor: '.gallery .product-thumbs-container'
		});

		$thumbs.slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			swipe: false,
			focusOnSelect: true,
    		accessibility: true,
			asNavFor: '.gallery .product-images-container'
		});

		$(document).on('click', '.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer .pplr-swatch-element', onOptionInteraction);

		function onOptionInteraction(e) {
			if ($images.slick('slickCurrentSlide') !== 0){
				$images.slick('slickGoTo', 0, true); // no animation
			}
		}

		// Re-init/re-show the configurator after going back to slide 0
		$images.on('afterChange', function (e, slick, current) {
			if (current !== 0) return;
			if (current === 0) {
				var $activeColor = $('.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer .pplr-color-options').find('.pplr-swatch-element.selected');
				if ($activeColor.length) {
					$activeColor.removeClass('selected').trigger('click');
				}
			}
		});

		$('.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer').on('click', '.pplr-swatch-element', function(event) {
			renderTotal();
		});

		$(document).on('change', '.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer select', function(event) {
			renderTotal();
		});

		watchForChanges('.pplr-container', function() {
			renderTotal();
		});

		function formatCents(cents){
			if (window.Shopify && typeof Shopify.formatMoney === 'function') {
				var fmt = (window.theme && theme.moneyFormat) || '${{amount}}';
				return Shopify.formatMoney(cents, fmt);
			}
			return (cents/100).toLocaleString(undefined, {style:'currency', currency:'USD'});
		}

		function parseMoneyToCents(str) {
			str = $.trim(String(str || ''));
			str = str.replace(/[^\d.-]/g, '');
			var n = parseFloat(str);
			return isNaN(n) ? 0 : Math.round(n * 100);
		}

		function renderTotal() {
			var $pricenode = $('.cur-section.cur-product-accessories-hero .info .price-wrapper');

			var basePriceCents = parseInt($pricenode.children('.price').data('base-price'), 10) || 0;
			var comparePriceCents = parseInt($pricenode.children('.compare-price').data('compare-price'), 10) || 0;

			var totalPrice = basePriceCents + selectedUpchargeCents();
			var totalComparePrice = comparePriceCents + selectedUpchargeCents();

			$pricenode.children('.price').data('current-price', totalPrice);
			$pricenode.children('.price').text(formatCents(totalPrice));
			$pricenode.children('.compare-price').text(formatCents(totalComparePrice));
			
		}

		function selectedUpchargeCents() {
			var total = 0;

			// existing: swatch upcharges
			$('.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer .pplr-swatch-element:visible').each(function() {
				var $swatch = $(this);
				if ($swatch.hasClass('selected')) {
					var price = parseFloat($swatch.data('pplr_price'));
					total = total + parseMoneyToCents(price);
				}
			});

			// new: dropdown upcharges (hinge placement, etc.)
			$('.cur-section.cur-product-accessories-hero [id^="pplr-"].product-personalizer select:visible').each(function() {
				var $select = $(this);
				var $opt = $select.find('option:selected');

				// Preferred: price lives on the option (most common)
				var price = $opt.data('pplr_price');

				// Fallbacks: other possible attribute names / placements
				if (price === undefined) price = $opt.data('price');
				if (price === undefined) price = $select.data('pplr_price');
				if (price === undefined) price = $select.data('price');

				// Last resort: parse from label text like "Right (+$150)" or "+$150"
				if (price === undefined || price === '' || price === null) {
					var t = String($opt.text() || '');
					var m = t.match(/\+\s*\$?\s*([\d,]+(?:\.\d+)?)/);
					price = m ? m[1].replace(/,/g, '') : 0;
				}

				total = total + parseMoneyToCents(price);
			});

			return total;
		}

		function watchForChanges(selector, callback) {
			var $container = $(selector);

			if (!$container.length) return;

			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.addedNodes.length) {
						callback();
						return false; // stop looping once we've triggered
					}
				});
			});

			observer.observe($container[0], { childList: true, subtree: true });
		}

		$(document).on('click', '.yotpo-reviews-star-ratings-widget button.yotpo-sr-bottom-line-button', function(event) {
			event.preventDefault();

			var $tabsContainer = $('.cur-product-accessories-content .content-tabs .tabs-container');
			var $reviewsTab    = $('.cur-product-accessories-content .content-tabs .tabs-container .tab[data-tab="reviews"');		

			var offsetTop = $tabsContainer.offset().top - 120;

			$('html, body').animate({ scrollTop: offsetTop }, 500, function() {
				$reviewsTab.trigger('click');
			});

		});

		// --- Sticky price scroll handler ---
		// DOM references cached outside the handler so they're not re-queried on every scroll event.
		var $overviewprice = $('.cur-section.cur-product-accessories-hero .info .overview .price-wrapper');
		var $stickyprice   = $('.cur-section.cur-product-accessories-hero .info .sticky-price .price-wrapper');
		var $mobilegallery = $('.pplrabs');

		// matchMedia result cached and only re-evaluated on resize, not every scroll.
		var ismobile = window.matchMedia('(max-width: 991.98px)').matches;

		var scrollTicking = false;

		function handleStickyPrice() {
			if (!$overviewprice.length || !$stickyprice.length) return;

			var pricerect = $overviewprice[0].getBoundingClientRect();

			// Trigger if price top is past viewport top
			var trigger = (pricerect.top <= 0);

			// On mobile, also trigger if price top collides with / goes under .pplrabs
			if (ismobile && $mobilegallery.length) {
				var galleryrect = $mobilegallery[0].getBoundingClientRect();

				// price top hits the bottom edge of the sticky image area
				if (pricerect.top <= galleryrect.bottom) {
					trigger = true;
				}
			}

			if (trigger) {
				$stickyprice.addClass('show-price');
			} else {
				$stickyprice.removeClass('show-price');
			}

			scrollTicking = false;
		}

		$(window).on('scroll', function() {
			// requestAnimationFrame throttle: defers layout reads until the browser
			// is ready, preventing forced synchronous reflows mid-scroll that can
			// cause Chrome on Android to jump back to the top of the page.
			if (!scrollTicking) {
				window.requestAnimationFrame(handleStickyPrice);
				scrollTicking = true;
			}
		});

		$(window).on('resize', function() {
			// Re-evaluate the breakpoint on resize, then run the handler immediately.
			ismobile = window.matchMedia('(max-width: 991.98px)').matches;
			handleStickyPrice();
		});

	});
})(jQuery);